module.exports = __webpack_public_path__ + "img/andes.6cf3d211.png";